export function getUserDisplayName(user) {
  return user.display_name ? user.display_name : user.name
}



// WEBPACK FOOTER //
// ./src/utils/name.js